export default "__VITE_ASSET__CHfcePYR__"